export enum TicketMessageType {
    INCOMINGMAIL = 42,
    OUTGOINGMAIL = 43
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/ticket-message-type.enum.ts